import React, { useEffect, useState } from 'react';

import { Typography } from 'antd';
import VisuPlantNetwork from '../component/PlantNetworkPlain';
import useFetch from '../hooks/fetcher';
import { useHistory } from 'react-router-dom';
import { useParams } from 'react-router-dom';

const API_SERVICE_BASE_URL = process.env.REACT_APP_API_SERVICE_BASE_URL || '';

const { Title } = Typography;

// backend response datatype
type PlantNetworkType = {
    botanical_name: { botanical_name: string; botanical_id: string }[];
    common_name: { common_name: string }[];
    synonyms: { synonyms: string }[];
    chinese_pharmaceutical_name: { chinese_pharmaceutical_name: string; chinese_id: string }[];
    pharmaceutical_latin_name: { pharmaceutical_latin_name: string; chinese_id: string }[];
    pinyin: { pinyin: string; chinese_id: string }[];
};

const dataProcessor = (data: PlantNetworkType): ChartType => {
    const processed: ChartType = {
        name: data.botanical_name[0].botanical_name,
        botanical_id: data.botanical_name[0].botanical_id,
        children: [
            {
                name: 'synonyms',
                children: data.synonyms.map((e) => ({ name: e.synonyms })),
            },
            {
                name: 'common_name',
                children: data.common_name.map((e) => ({ name: e.common_name })),
            },
            {
                name: 'chinese_pharmaceutical_name',
                children: data.chinese_pharmaceutical_name.map((e) => ({
                    name: e.chinese_pharmaceutical_name,
                    chinese_id: e.chinese_id,
                })),
            },
            {
                name: 'pharmaceutical_latin_name',
                children: data.pharmaceutical_latin_name.map((e) => ({
                    name: e.pharmaceutical_latin_name,
                    chinese_id: e.chinese_id,
                })),
            },
            {
                name: 'pinyin',
                children: data.pinyin.map((e) => ({ name: e.pinyin, chinese_id: e.chinese_id })),
            },
        ],
    };
    return processed;
};

const PagePlantContext: React.FC = () => {
    const [result, setResult] = useState<ChartType>({ name: '' });
    const [winSize, setWinSize] = useState<{ width: number; height: number }>({ width: 0, height: 0 });
    const { get } = useFetch(API_SERVICE_BASE_URL);
    const { table, column, name, bid } = useParams<any>();
    const history = useHistory();
    useEffect(() => {
        get('/api/plant_network_idx.php', { name: bid }).then((r: PlantNetworkType) => setResult(dataProcessor(r)));
    }, []);

    useEffect(() => {
        const handleResize = (): void => {
            // console.log('w:' + window.innerWidth + ', h:' + window.innerHeight);
            setWinSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        };
        handleResize();
        window.addEventListener('resize', handleResize);
        return (): void => window.removeEventListener('resize', handleResize);
    }, []);
    return (
        <div>
            <Title level={2}>Network: {name}</Title>
            <Typography.Paragraph>
                As the root of the network is the accepted botanical name that is linked to botanical synonyms, common
                plant names, chinese pharmaceutical name, pharmaceutical latin name and transliteration (pinyin). If you
                click on the underlined strings (accepted botanical name, chinese pharmaceutical name, pharmaceutical
                latin name and pinyin), you will be directed to the detailed page for each plant/ “herb” respectively.
            </Typography.Paragraph>

            <VisuPlantNetwork
                width={winSize.width - 200}
                height={winSize.height - 100}
                data={result}
                history={history}
                botanicalId={result.botanical_id}
            />
        </div>
    );
};

export default PagePlantContext;
